module.exports = __webpack_public_path__ + "static/media/promo.ed99abbc.png";